export default __webpack_public_path__ + "static/media/mynextLogo.26f1c0c3.png";